import PropTypes from 'prop-types';
import React from 'react';

const IframedPage = (props) => {
  const {
    header,
    subHeader,
    wrapperClassName,
    src,
  } = props;

  const headerBlock = header ? <h3 className="heading_b">{header}</h3> : null;
  const subHeaderBlock = header ? <h3 className="heading_a">{subHeader}</h3> : null;

  return (
    <div className={wrapperClassName}>
      <div className="uk-grid">
        <div className="uk-width-medium-1-1">
          {headerBlock}
          {subHeaderBlock}
          <iframe
            title="iframe page"
            width="100%"
            height="700"
            className="iframe-page"
            src={src}
          />
        </div>
      </div>
    </div>
  );
};

IframedPage.propTypes = {
  header: PropTypes.string,
  subHeader: PropTypes.string,
  wrapperClassName: PropTypes.string,
  src: PropTypes.string,
};

export default IframedPage;



// WEBPACK FOOTER //
// ./src/components/IframedPage.js